export function showSnackBar(text: string = "") {
  const arg = [text];

  window.flutter_inappwebview?.callHandler("showSnackBar", arg);
}

export function navigatorPushReplaceScreen(url: string, callback?: Function) {
  const arg = [url];

  window.flutter_inappwebview
    ?.callHandler("navigatorPushReplaceScreen", arg)
    .then(function (result: any) {
      if (callback) {
        callback(result);
      }
    });
}

export function navigatorPushResultScreen(
  url: string,
  title: string = "",
  type: string = "normal",
  callback?: Function
) {
  const arg = [url, type, title];

  window.flutter_inappwebview
    ?.callHandler("navigatorPushResultScreen", arg)
    .then(function (result: any) {
      if (callback) {
        callback(result);
      }
    });
}

export function navigatorRoutePushScreen(
  url: string,
  data?: any,
  callback?: Function
) {
  const arg = [url, String(data)];
  window.flutter_inappwebview
    ?.callHandler("navigatorRoutePushScreen", arg)
    .then(function (result: any) {
      if (callback) {
        callback(result);
      }
    });
}

export function getStep() {
  return window.flutter_inappwebview?.callHandler("getStep");
}

export function resetStep() {
  return window.flutter_inappwebview?.callHandler("resetStep");
}

export function navigatorPopScreen(args?: any) {
  window.flutter_inappwebview?.callHandler("navigatorPopScreen", [args]);
}

export function navigatorPushEditHealth() {
  window.flutter_inappwebview
    ?.callHandler("navigatorPushEditHealth")
    .then(function (result: any) {});
}

export function writeAccessToken(accessToken: string) {
  window.flutter_inappwebview?.callHandler("writeAccessToken", [accessToken]);
}

export async function readAccessToken() {
  return await window.flutter_inappwebview?.callHandler("readAccessToken");
}

export async function readRefreshToken() {
  return await window.flutter_inappwebview?.callHandler("readRefreshToken");
}
export async function login(
  accessToken: string,
  refreshToken: string,
  callback?: Function
) {
  return await window.flutter_inappwebview
    ?.callHandler("login", [accessToken, refreshToken])
    .then(function (result: any) {
      if (callback) {
        console.log(result, "result");
        callback(result);
      }
    });
}

// 프로필 아이디 선택시 프로필 아이디 저장( 플러터 로컬 스토리지)
export function selectProfileId(profileId: string, callback?: Function) {
  window.flutter_inappwebview
    ?.callHandler("selectProfileId", [profileId])
    .then(function (result: any) {
      if (callback) {
        console.log(result, "result");
        callback(result);
      }
    });
}

// 프로필 아이디 읽기( 플러터 로컬 스토리지)
export async function readProfileId() {
  return await window.flutter_inappwebview?.callHandler("readProfileId");
}
// 프로필 아이디 삭제( 플러터 로컬 스토리지)
export async function deleteProfileId() {
  return await window.flutter_inappwebview?.callHandler("deleteProfileId");
}

export async function deleteAccessToken() {
  return await window.flutter_inappwebview?.callHandler("deleteAccessToken");
}

export async function deleteRefreshToken() {
  return await window.flutter_inappwebview?.callHandler("deleteRefreshToken");
}

export function logout(callback?: Function) {
  window.flutter_inappwebview?.callHandler("logout").then(callback);
}

// 공유하기 버튼
export async function _handleShareBoard(
  title: any,
  url: string,
  callback?: Function
) {
  const args = { title, url };

  window.flutter_inappwebview?.callHandler("shareBoard", args).then(callback);
}

// 앱 권한 요청 버튼
export function getUserPermissionsRequest() {
  return window.flutter_inappwebview?.callHandler("requestPermissions");
}

// 사용자 현재 위치
export function getUserCurrentPostion() {
  return window.flutter_inappwebview?.callHandler("currentPosition");
}

// FCM 토큰 저장
export const saveFcmToken = (data: any) => {
  const args = { ...data };

  // webview_flutter의 JavaScript 채널로 메시지 전송
  window.flutter_inappwebview?.callHandler("saveFcmToken", args);
};
